<template>
  <i18n :path="path" tag="div">
    <!-- eslint-disable-next-line -->
    <template v-for="(value, key) in params" v-slot:[key]>
      {{ $te(value) ? $t(value) : value }}
    </template>
    <template v-slot:link>
      <router-link :to="link.href">{{ $t(link.label) }}</router-link>
    </template>
  </i18n>
</template>

<script>
  export default {
    props: {
      path: {
        type: String,
        default: null
      },

      link: {
        type: Object,
        default: () => ({
          href: '',
          label: ''
        })
      },

      params: {
        type: Object,
        default: () => ({})
      }
    }
  };
</script>
